import { FileModel } from "src/models/FileModel";
import BillingCategoryModel from "./BillingCategoryModel";
import ClassModel from "./ClassModel";
import DepartmentModel from "./DepartmentModel";

class ProgramModel {
  active?: boolean = true;
  billingCategory?: BillingCategoryModel;
  classes?: ClassModel[] = [];
  department?: DepartmentModel;
  description?: string = "";
  evaluationReminderFrequency?: number;
  images?: FileModel[] = [];
  id: string;
  skills?: string[] = [];
  title: string = "";

  constructor(data: ProgramModel | {}) {
    Object.assign(this, data);
  }
}

export default ProgramModel;
